import React from 'react';
export function TabPanel(props) {
    const { children, currentTabIndex, targetIndex, id, 'aria-labelledby': ariaLabelledBy, 'data-qa-id': dataQaId } = props;
    return (React.createElement("div", { hidden: currentTabIndex !== targetIndex, id: id, "data-qa-id": dataQaId, "aria-labelledby": ariaLabelledBy }, currentTabIndex === targetIndex && children));
}
